export default "__VITE_ASSET__557ffcee__"